import { connect, type MapDispatchToProps, type MapStateToProps } from 'react-redux';
import { InlineJoinButton } from './index';
import { type State } from '../../../state/types';
import { type StateProps, type OwnProps, type DispatchProps } from './types';
import { inlineJoinConfluence } from '../../../state/actions';
import { getIsInlineJoinPending } from '../../../state/ui/inline-join/selectors';

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (
	state: State,
): StateProps => ({
	isInlineJoinPending: getIsInlineJoinPending(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (dispatch) => ({
	triggerInlineJoin: () => dispatch(inlineJoinConfluence()),
});

export default connect<StateProps, DispatchProps, OwnProps, State>(
	mapStateToProps,
	mapDispatchToProps,
)(InlineJoinButton);
